import { render, staticRenderFns } from "./AccountStudentProfile.vue?vue&type=template&id=78b318d6&scoped=true&"
import script from "./AccountStudentProfile.vue?vue&type=script&lang=js&"
export * from "./AccountStudentProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b318d6",
  null
  
)

export default component.exports